export const AREA_SEARCH_MIN_CHARS = 3;

export const AREA_GROUPS = [
  ["city", "City"],
  ["county", "County"],
  ["postalCode", "Zip/Postal"],
  ["neighborhood", "Neighborhood"],
  ["schoolDistrict", "School District"],
];

export const AREA_GROUPS_WITH_ADDRESS = [...AREA_GROUPS, ["address", "Address"]];
